import CompanyLogo from "~/components/CompanyLogo";
import NotificationBell from "~/components/NotificationBell";
import ProfileDropdown from "~/molecules/ProfileDropdown";

const HeaderProfile = () => (
  <>
    <div className="sticky top-0 z-40 lg:mx-auto">
      <div className="flex h-16 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8 lg:shadow-none">
        <div className="flex shrink-0 items-center">
          <CompanyLogo />
        </div>

        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <div className="ml-auto flex items-center gap-x-4 lg:gap-x-6">
            <NotificationBell />

            {/* Separator */}
            <div className="block h-6 w-px bg-gray-200" aria-hidden="true" />

            <ProfileDropdown />
          </div>
        </div>
      </div>
    </div>
  </>
);

export default HeaderProfile;
